import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const greyPaper = styled(Paper)`
  padding: 30px;
  border-radius: 30px;
`;

export default greyPaper;
